/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import uuid from "react-uuid";

import {
  failureAction,
  onEntryAction,
  onErrorAction,
  onExitAction,
  resetAction,
  successAction,
  VappMachineConfig,
} from "../../../StateMachineService";
import {
  getPageContentFromServer,
  formatProfileCard,
  formatBreadcrumb,
  checkIfLeafNode,
  formatCollectionChildren,
  getLeafNodes,
  formatLeafNodes,
} from "./states";

const GET_PAGE_CONTENT_CONFIG: VappMachineConfig = {
  id: "services.PortfolioForReviewPageService.machines.GetPageContent",
  initial: "IDLE",
  predictableActionArguments: true,
  context: {},
  states: {
    IDLE: {
      on: {
        START: {
          target: "GET_PAGE_CONTENT_FROM_SERVER",
          actions: [successAction],
        },
      },
    },
    GET_PAGE_CONTENT_FROM_SERVER: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "getPageContentFromServer",
        src: getPageContentFromServer,
        onDone: {
          target: "FORMAT_PROFILE_CARD",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    FORMAT_PROFILE_CARD: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "formatProfileCard",
        src: formatProfileCard,
        onDone: {
          target: "FORMAT_BREADCRUMB",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    FORMAT_BREADCRUMB: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "formatBreadcrumb",
        src: formatBreadcrumb,
        onDone: {
          target: "CHECK_IF_LEAF_NODE",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    CHECK_IF_LEAF_NODE: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "checkIfLeafNode",
        src: checkIfLeafNode,
        onDone: {
          target: "GET_LEAF_NODES",
          actions: [successAction],
        },
        onError: {
          target: "FORMAT_COLLECTION_CHILDREN",
          actions: [failureAction],
        },
      },
    },
    FORMAT_COLLECTION_CHILDREN: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "formatCollectionChildren",
        src: formatCollectionChildren,
        onDone: {
          target: "END",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    GET_LEAF_NODES: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "getLeafNodes",
        src: getLeafNodes,
        onDone: {
          target: "FORMAT_LEAF_NODES",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    FORMAT_LEAF_NODES: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "formatLeafNodes",
        src: formatLeafNodes,
        onDone: {
          target: "END",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    END: {
      type: "final",
    },
    ERROR: {
      type: "final",
    },
  },
  extendContextWith: function (extContext: any) {
    //@ts-ignore
    this.id = uuid();
    this.context = { ...this.context, ...extContext };
    return this;
  },
};
export { GET_PAGE_CONTENT_CONFIG };
